/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'info-black': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<g _fill="none" fill-rule="evenodd"><circle pid="0" _fill="#404040" cx="6" cy="6" r="6"/><g transform="translate(4.75 2.667)" _fill="#FFF"><path pid="1" d="M1.571 5.254l.196-.788.432-1.744a.58.58 0 0 0-.423-.702l-.056-.014a.583.583 0 0 0-.113-.017v-.011l-.025.011c-.178 0-.438.172-.438.172-.506.353-1.198.82-1.095 1.043.155.337.913-.55.731.181l-.195.788-.433 1.744c-.077.311.087.62.398.696l.056.014c.038.01.076.015.113.017v.011l.025-.011c.178 0 .439-.173.439-.173.505-.352 1.21-.816 1.107-1.039-.155-.337-.9.553-.719-.178z"/><circle pid="2" cx="1.491" cy=".824" r="1"/></g></g>'
  }
})
